// src/pages/UpdateSchedulePage.js
import React from 'react';
import ResponsiveTypography from '../components/ResponsiveTypography';

const { Title, Text } = ResponsiveTypography;

const h1Style = {
    fontSize: '1.5rem',
    fontWeight: '600',
    borderBottom: '1px solid #d0d7de',
    paddingBottom: '0.75rem',
    marginBottom: '1.5rem',
    transition: 'font-size 0.2s ease-in-out',
};

const itemStyle = {
  padding: '1rem 1.5rem',
  marginBottom: '1rem',
  border: '1px solid #d0d7de',
  borderRadius: '0.375rem'
};

const dateStyle = {
  display: 'block',
  fontSize: '0.8rem',
  fontWeight: 'bold',
  color: '#0969da',
  marginBottom: '0.5rem',
};

const scheduleTextStyle = {
  transition: 'font-size 0.2s ease-in-out',
};

const UpdateSchedulePage = () => {
  return (
    <div className="content-box">
      <Title level={3} style={h1Style}>향후 업데이트 일정</Title>
      
      <div style={itemStyle}>
        <Text style={dateStyle}>2025년 4분기</Text>
        <Text style={scheduleTextStyle}>[주도주] 한국 & 미국 주도주 및 AI 주가 상승 분석</Text>
      </div>

      <div style={itemStyle}>
        <Text style={dateStyle}>2026년 1분기</Text>
        <Text style={scheduleTextStyle}>[종목분석] 주가 vs 주요 어닝 지표 비교 차트 기능 추가</Text>
      </div>

      <div style={itemStyle}>
        <Text style={dateStyle}>지속적 업데이트</Text>
        <Text style={scheduleTextStyle}>사용자 피드백 반영 및 데이터 소스 확장, UI/UX 개선</Text>
      </div>
    </div>
  );
};

export default UpdateSchedulePage;